<template>
  <div class="e-loader">
    <div class="e-loader__img">
      <img src="@/assets/img/loader-animation.gif" alt="Loader...">
    </div>
    <div class="e-loader__text">Fetching product information...</div>
  </div>
</template>

<script>

export default {
  name: 'LoaderScreen',
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss">
</style>
